export const navLinks = [
  { label: '线索速览', href: '#clues' },
  { label: '证据链', href: '#evidence' },
  { label: '关系图', href: '#relation' },
  { label: '时间脉络', href: '#timeline' },
  { label: '讨论区', href: '#discussion' },
];

export const heroKeywords = [
  '网爆黑料证据链',
  '资金往来',
  '合同文件',
  '内部邮件',
  '人物关系图',
];

export const clueCategories = [
  { id: 'all', label: '全部线索' },
  { id: 'fund', label: '资金往来' },
  { id: 'contract', label: '合同文件' },
  { id: 'mail', label: '内部邮件' },
  { id: 'relation', label: '人物关系' },
];

export const clueItems = [
  {
    id: 'hj-0931',
    code: 'HJ-0931',
    title: '分三笔转账绕开大额提示，收款账户同源',
    summary: '三笔款项间隔不足 20 分钟，最终归集到同一个二级账户。',
    category: 'fund',
    tags: ['资金往来', '同源账户'],
    time: '09-08 21:14',
    heat: 9860,
    evidence: 12,
    stage: '已比对',
  },
  {
    id: 'hj-0927',
    code: 'HJ-0927',
    title: '补充协议签署日期与履约时间对不上',
    summary: '协议标注 3 月签署，但履约凭证却出现在 1 月。',
    category: 'contract',
    tags: ['合同文件', '时间矛盾'],
    time: '09-08 18:02',
    heat: 8320,
    evidence: 9,
    stage: '待核验',
  },
  {
    id: 'hj-0921',
    code: 'HJ-0921',
    title: '抄送名单里出现第三方公司邮箱',
    summary: '邮件正文未提及该公司，但被稳定抄送整条沟通链。',
    category: 'mail',
    tags: ['内部邮件', '第三方'],
    time: '09-08 15:47',
    heat: 7710,
    evidence: 15,
    stage: '已比对',
  },
  {
    id: 'hj-0916',
    code: 'HJ-0916',
    title: '两个看似无关的主体共用同一注册地址',
    summary: '注册地址、联系电话完全一致，登记年份相差两年。',
    category: 'relation',
    tags: ['人物关系', '主体关联'],
    time: '09-08 12:33',
    heat: 7480,
    evidence: 7,
    stage: '已比对',
  },
  {
    id: 'hj-0908',
    code: 'HJ-0908',
    title: '关联账户在事件曝光前一周集中转出',
    summary: '七个工作日连续转出，单日金额呈阶梯式上升。',
    category: 'fund',
    tags: ['资金往来', '时间敏感'],
    time: '09-07 22:05',
    heat: 6900,
    evidence: 11,
    stage: '待核验',
  },
  {
    id: 'hj-0902',
    code: 'HJ-0902',
    title: '同一份合同出现两个版本，盖章位置不同',
    summary: '两份扫描件的页眉页脚一致，但落章偏移明显。',
    category: 'contract',
    tags: ['合同文件', '版本冲突'],
    time: '09-07 19:21',
    heat: 6540,
    evidence: 8,
    stage: '已比对',
  },
  {
    id: 'hj-0895',
    code: 'HJ-0895',
    title: '邮件中的项目代号与公开项目无法对应',
    summary: '代号在对外文件中从未出现，仅内部流转使用。',
    category: 'mail',
    tags: ['内部邮件', '代号'],
    time: '09-07 16:09',
    heat: 6120,
    evidence: 6,
    stage: '线索中',
  },
  {
    id: 'hj-0889',
    code: 'HJ-0889',
    title: '中间人同时出现在双方付款审批流程中',
    summary: '同一位签字人既是付款方审批，也是收款方对接。',
    category: 'relation',
    tags: ['人物关系', '交叉角色'],
    time: '09-07 11:40',
    heat: 5980,
    evidence: 10,
    stage: '待核验',
  },
  {
    id: 'hj-0881',
    code: 'HJ-0881',
    title: '报销单据金额与合同付款节点高度吻合',
    summary: '五张单据金额相加，恰好等于合同第二期款。',
    category: 'fund',
    tags: ['资金往来', '金额吻合'],
    time: '09-06 20:18',
    heat: 5610,
    evidence: 5,
    stage: '已比对',
  },
  {
    id: 'hj-0874',
    code: 'HJ-0874',
    title: '终止条款被临时修改，修改痕迹未清理',
    summary: '文档属性中保留了两位不同的最后保存者。',
    category: 'contract',
    tags: ['合同文件', '文档属性'],
    time: '09-06 17:52',
    heat: 5340,
    evidence: 4,
    stage: '线索中',
  },
  {
    id: 'hj-0866',
    code: 'HJ-0866',
    title: '关键时间点群发邮件附件命名规律一致',
    summary: '附件名均采用同一套内部编号规则，跨越四个季度。',
    category: 'mail',
    tags: ['内部邮件', '编号规则'],
    time: '09-06 14:26',
    heat: 5020,
    evidence: 9,
    stage: '已比对',
  },
  {
    id: 'hj-0857',
    code: 'HJ-0857',
    title: '担保方与收款方存在交叉持股关系',
    summary: '两条工商信息指向同一位自然人股东。',
    category: 'relation',
    tags: ['人物关系', '交叉持股'],
    time: '09-06 10:07',
    heat: 4760,
    evidence: 6,
    stage: '待核验',
  },
  {
    id: 'hj-0849',
    code: 'HJ-0849',
    title: '多笔小额转账在短时间内拼接为大额',
    summary: '单笔均低于提示阈值，合计后触发对账异常。',
    category: 'fund',
    tags: ['资金往来', '拆分转账'],
    time: '09-05 21:33',
    heat: 4410,
    evidence: 13,
    stage: '已比对',
  },
  {
    id: 'hj-0842',
    code: 'HJ-0842',
    title: '验收单签字人未出现在项目人员名单中',
    summary: '签字人的岗位信息在公开资料中查无对应。',
    category: 'contract',
    tags: ['合同文件', '人员存疑'],
    time: '09-05 16:48',
    heat: 4180,
    evidence: 3,
    stage: '线索中',
  },
];

export interface EvidenceTypeItem {
  id: string;
  name: string;
  icon: string;
  count: string;
  unit: string;
  desc: string;
  gridClass: string;
  big: boolean;
  facts: { label: string; value: string }[];
}

export const evidenceTypes: EvidenceTypeItem[] = [
  {
    id: 'fund',
    name: '资金往来',
    icon: 'ri-exchange-dollar-line',
    count: '3,215',
    unit: '笔',
    desc: '按账户、时间、金额三层归档，标注拆分转账与同源归集路径。',
    gridClass: 'lg:col-span-3 lg:row-span-2',
    big: true,
    facts: [
      { label: '已锁定账户', value: '146' },
      { label: '异常归集', value: '28' },
      { label: '时间跨度', value: '19 个月' },
    ],
  },
  {
    id: 'contract',
    name: '合同文件',
    icon: 'ri-file-text-line',
    count: '1,286',
    unit: '份',
    desc: '比对版本、落章与文档属性，标出签署时间与履约时间的矛盾点。',
    gridClass: 'lg:col-span-3',
    big: false,
    facts: [],
  },
  {
    id: 'mail',
    name: '内部邮件',
    icon: 'ri-mail-line',
    count: '4,702',
    unit: '封',
    desc: '梳理抄送关系与附件编号规律，还原内部沟通链路。',
    gridClass: 'lg:col-span-3',
    big: false,
    facts: [],
  },
  {
    id: 'relation',
    name: '人物关系图',
    icon: 'ri-node-tree',
    count: '412',
    unit: '个节点',
    desc: '把当事主体、中间人、担保方串成一张可点选的关系网络。',
    gridClass: 'lg:col-span-4',
    big: false,
    facts: [],
  },
  {
    id: 'timeline',
    name: '时间线',
    icon: 'ri-time-line',
    count: '168',
    unit: '个事件',
    desc: '按发生、曝光、回应三个阶段对齐时间，方便逐条交叉核对。',
    gridClass: 'lg:col-span-2',
    big: false,
    facts: [],
  },
];

export const relationNodes = [
  {
    id: 'n1',
    name: '陈某',
    role: '关联公司法人',
    x: 50,
    y: 10,
    tag: '核心外围',
    weight: 82,
    note: '名下两家公司分别出现在付款方与收款方的登记信息中。',
  },
  {
    id: 'n2',
    name: '李某',
    role: '资金经手人',
    x: 84,
    y: 27,
    tag: '关键节点',
    weight: 91,
    note: '连续 14 个月经手同一批次的拆分转账，操作时段集中。',
  },
  {
    id: 'n3',
    name: '王某',
    role: '项目对接人',
    x: 84,
    y: 73,
    tag: '沟通中枢',
    weight: 88,
    note: '内部邮件的发件主力，抄送名单由其维护。',
  },
  {
    id: 'n4',
    name: '赵某',
    role: '前合作方',
    x: 50,
    y: 90,
    tag: '外围线索',
    weight: 64,
    note: '合同终止后仍在履约记录中留有签字痕迹。',
  },
  {
    id: 'n5',
    name: '孙某',
    role: '担保方代表',
    x: 16,
    y: 73,
    tag: '关键节点',
    weight: 79,
    note: '担保主体与收款主体存在交叉持股，指向同一位股东。',
  },
  {
    id: 'n6',
    name: '周某',
    role: '邮件抄送人',
    x: 16,
    y: 27,
    tag: '沟通中枢',
    weight: 71,
    note: '长期被抄送但从未在正文中被提及，身份待核实。',
  },
];

export const relationHub = {
  name: '核心当事人',
  role: '事件中心',
  note: '所有资金、合同与邮件线索最终都指向该主体，是关系网络的中枢节点。',
};

export const timelineEvents = [
  {
    id: 't1',
    date: '2024.03.12',
    title: '首份合作合同签署',
    desc: '合同主体、金额与付款节点首次出现，后续矛盾均以此为起点。',
    tag: '合同文件',
    evidence: 6,
  },
  {
    id: 't2',
    date: '2024.05.28',
    title: '第一笔大额资金到账',
    desc: '款项分两笔汇入，间隔不到半小时，收款账户为同一主体。',
    tag: '资金往来',
    evidence: 9,
  },
  {
    id: 't3',
    date: '2024.09.04',
    title: '补充协议签署',
    desc: '协议修改了终止条款，文档属性中保留两位保存者记录。',
    tag: '合同文件',
    evidence: 4,
  },
  {
    id: 't4',
    date: '2025.01.16',
    title: '内部邮件沟通密度上升',
    desc: '同期邮件量增至平时三倍，抄送名单出现第三方邮箱。',
    tag: '内部邮件',
    evidence: 12,
  },
  {
    id: 't5',
    date: '2025.04.22',
    title: '关联账户集中转出',
    desc: '七个工作日内连续转出，单日金额呈阶梯式上升。',
    tag: '资金往来',
    evidence: 11,
  },
  {
    id: 't6',
    date: '2025.06.30',
    title: '项目提前终止',
    desc: '终止时间与验收单签字时间相差 11 天，签字人身份存疑。',
    tag: '合同文件',
    evidence: 5,
  },
  {
    id: 't7',
    date: '2025.08.05',
    title: '线索集中曝光，进入比对阶段',
    desc: '多方资料汇总后，时间脉络首次被完整对齐。',
    tag: '关系图',
    evidence: 18,
  },
];

export const statItems = [
  { label: '已收录线索', value: '1,286', unit: '条', note: '近 7 日 +142' },
  { label: '证据条目', value: '9,470', unit: '项', note: '含截图与文件' },
  { label: '涉及资金笔数', value: '3,215', unit: '笔', note: '已标注异常 28 笔' },
  { label: '关系节点', value: '412', unit: '个', note: '核心节点 36 个' },
  { label: '已梳理事件', value: '168', unit: '起', note: '跨 19 个月' },
];

export const trendBars = [
  { label: '09/02', value: 42 },
  { label: '09/03', value: 58 },
  { label: '09/04', value: 51 },
  { label: '09/05', value: 74 },
  { label: '09/06', value: 66 },
  { label: '09/07', value: 88 },
  { label: '09/08', value: 96 },
];

export const discussions = [
  {
    id: 'd1',
    user: '夜深不打烊',
    avatar: '夜',
    time: '12 分钟前',
    content: '资金那条线对得最整齐，三笔转账的时间间隔太刻意了，建议把账户变动一起放进时间线。',
    likes: 328,
    replies: 46,
    tag: '资金往来',
  },
  {
    id: 'd2',
    user: '只信原件',
    avatar: '原',
    time: '38 分钟前',
    content: '合同两个版本这个点很关键，落章偏移基本能说明不是同一次签署的。求把文档属性和扫描件放一起看。',
    likes: 271,
    replies: 33,
    tag: '合同文件',
  },
  {
    id: 'd3',
    user: '脉络整理癖',
    avatar: '脉',
    time: '1 小时前',
    content: '关系图里孙某和周某这两条我反复看了几遍，交叉持股那条如果坐实，整条链就闭环了。',
    likes: 205,
    replies: 28,
    tag: '人物关系',
  },
  {
    id: 'd4',
    user: '理性吃瓜',
    avatar: '理',
    time: '2 小时前',
    content: '提醒一下，目前大多是疑点不是结论，邮件抄送也不等于知情，还是等更多原始材料再下判断。',
    likes: 419,
    replies: 57,
    tag: '内部邮件',
  },
];

export const methodSteps = [
  {
    id: 'm1',
    icon: 'ri-file-search-line',
    title: '先归档，再下结论',
    desc: '所有材料按资金、合同、邮件、关系四类归档，来源与时间逐条标注，不做无来源转述。',
  },
  {
    id: 'm2',
    icon: 'ri-scales-3-line',
    title: '多方比对，标注矛盾',
    desc: '同一事件至少用两种以上材料交叉核对，矛盾之处单独标出，而不是直接抹平。',
  },
  {
    id: 'm3',
    icon: 'ri-shield-check-line',
    title: '只梳理脉络，不下定性',
    desc: '本页仅呈现已被公开的材料与推断路径，所有结论请以官方通报与法律认定为准。',
  },
];

export const footerColumns = [
  {
    title: '深扒分区',
    links: [
      { label: '线索速览', href: '#clues' },
      { label: '证据链类型', href: '#evidence' },
      { label: '人物关系图', href: '#relation' },
      { label: '时间脉络', href: '#timeline' },
    ],
  },
  {
    title: '证据维度',
    links: [
      { label: '资金往来', href: '#evidence' },
      { label: '合同文件', href: '#evidence' },
      { label: '内部邮件', href: '#evidence' },
      { label: '关系图谱', href: '#relation' },
    ],
  },
  {
    title: '参与方式',
    links: [
      { label: '讨论区', href: '#discussion' },
      { label: '深扒方法论', href: '#method' },
      { label: '免责声明', href: '#method' },
      { label: '线索提交说明', href: '#method' },
    ],
  },
];